// Full-name rule, the same as the server's (_full_name_problem in backend/server.py):
// first and last name written out, each starting with a capital ("Anish Menon",
// "Mary-Ann D'Souza"); single-letter middle initials are fine ("Jomin P John").

const WORD = "(?:[A-Z]'[A-Z][a-z]+|[A-Z][a-z]+(?:['-][A-Z][a-z]+)*)";
const FULL_NAME = new RegExp(`^${WORD}(?: (?:${WORD}|[A-Z]))* ${WORD}$`);

const TITLES = new Set(["dr", "mr", "mrs", "ms", "miss", "prof", "md", "sri", "smt"]);

const tidy = (raw) => (raw || "").split(/\s+/).filter(Boolean).join(" ");

/** 'SARAYU  kopparapu' → 'Sarayu Kopparapu' (capitals and spacing only). */
export const suggestName = (raw) =>
  (raw || "").replace(/[.\s]+/g, " ").trim().split(" ").filter(Boolean)
    .map((w) => w.toLowerCase().replace(/(^|['-])([a-z])/g, (_, a, b) => a + b.toUpperCase()))
    .join(" ");

/** null if it's a proper full name, else what to fix. */
export function nameProblem(raw) {
  const name = tidy(raw);
  if (FULL_NAME.test(name)) return null;
  if (!name) return "Enter the full name (first and last name).";
  const words = name.split(/[\s.]+/).filter(Boolean);
  if (words.length < 2) return `Add the last name too. Full names only.`;
  if (TITLES.has(words[0].toLowerCase())) return "Leave out titles (Dr, Mr, Ms…) and write the full name.";
  const shouting = name.toUpperCase() === name;
  const isInitial = (w) => w.length < 2 || (!shouting && w === w.toUpperCase() && w.length <= 3);
  if (isInitial(words[0]) || isInitial(words[words.length - 1])) return "Write the first and last name in full, not as initials.";
  if (name.includes(".") || words.some((w) => w.length > 1 && isInitial(w))) return "Write the names out in full, not as initials (one middle initial like 'Jomin P John' is fine).";
  const fixed = suggestName(name);
  if (FULL_NAME.test(fixed)) return `Write it as "${fixed}".`;
  return "Use letters only, e.g. Anish Menon.";
}

/** On blur: fix capitals/spacing automatically when that's the only problem
 *  (never turns initials or titles like "MS" or "Dr." into fake names). */
export const autoFixName = (raw) => {
  const problem = nameProblem(raw);
  const fixed = suggestName(raw);
  return problem && problem.startsWith("Write it as") && FULL_NAME.test(fixed) ? fixed : tidy(raw);
};
